import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getMemberPrivacySettingsRequest = {};
var _getMemberPrivacySettingsResponse = {
    memberPrivacySettings: '_memberPrivacySettings',
};
var _memberPrivacySettings = { updatedDate: 'google.protobuf.Timestamp' };
var _setMemberPrivacySettingsRequest = {
    memberPrivacySettings: '_memberPrivacySettings',
};
var _setMemberPrivacySettingsResponse = {
    memberPrivacySettings: '_memberPrivacySettings',
};
function resolveComWixpressMembersMemberprivacysettingsMemberPrivacySettingsServiceUrl(opts) {
    var domainToMappings = {
        'editor.wixapps.net': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/members/v1/privacy-settings',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/members/v1/privacy-settings',
                destPath: '/v1/privacy-settings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the member privacy settings for a site.
 *
 * If no settings were set, the default settings are retrieved.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function getMemberPrivacySettings(payload) {
    var _a = serializer(_getMemberPrivacySettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberPrivacySettingsResponse, {
        _memberPrivacySettings: _memberPrivacySettings,
    }).fromJSON;
    function __getMemberPrivacySettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_privacy_settings',
            method: 'GET',
            methodFqn: 'com.wixpress.members.memberprivacysettings.MemberPrivacySettingsService.GetMemberPrivacySettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberprivacysettingsMemberPrivacySettingsServiceUrl({ protoPath: '/v1/privacy-settings', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMemberPrivacySettings.fromReq = fromReq;
    __getMemberPrivacySettings.__isAmbassador = true;
    return __getMemberPrivacySettings;
}
/**
 * Sets the member privacy settings for a site.
 *
 * Each time the member privacy settings are updated, `revision` increments by 1. The existing `revision` must be included when updating the member privacy settings. This ensures you're working with the latest member privacy settings and prevents unintended overwrites.
 */
export function setMemberPrivacySettings(payload) {
    var _a = serializer(_setMemberPrivacySettingsRequest, { _memberPrivacySettings: _memberPrivacySettings }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setMemberPrivacySettingsResponse, {
        _memberPrivacySettings: _memberPrivacySettings,
    }).fromJSON;
    function __setMemberPrivacySettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_privacy_settings',
            method: 'POST',
            methodFqn: 'com.wixpress.members.memberprivacysettings.MemberPrivacySettingsService.SetMemberPrivacySettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersMemberprivacysettingsMemberPrivacySettingsServiceUrl({ protoPath: '/v1/privacy-settings', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setMemberPrivacySettings.fromReq = fromReq;
    __setMemberPrivacySettings.__isAmbassador = true;
    return __setMemberPrivacySettings;
}
//# sourceMappingURL=http.impl.js.map